export const ACTION_EXCLUDE = 'exclude';
export const ACTION_INCLUDE = 'include';
export const DEFAULT_RADIUS = 100;
export const MAPGEOCODER_DEBOUNCE_TIMEOUT = 500;
export const ADDRESS_SEPARATOR = '|';
